const warrantyDialog = document.getElementById('mmooi-warranty-dialog');

if (warrantyDialog instanceof HTMLDialogElement && typeof warrantyDialog.showModal === 'function') {
  let previousTrigger;
  const prepareLinks = () => {
    for (const link of document.querySelectorAll('.mmooi-warranty__link')) {
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', warrantyDialog.id);
    }
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('a.mmooi-warranty__link');
    if (!link || warrantyDialog.open) return;

    event.preventDefault();
    previousTrigger = link;
    warrantyDialog.showModal();
    warrantyDialog.scrollTop = 0;
  });

  warrantyDialog.addEventListener('close', () => {
    if (previousTrigger?.isConnected) previousTrigger.focus({ preventScroll: true });
  });

  warrantyDialog.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('a[href="#mmooi-warranty-transcript-title"]')) {
      event.preventDefault();
      const heading = document.getElementById('mmooi-warranty-transcript-title');
      heading?.focus({ preventScroll: true });
      heading?.scrollIntoView({ block: 'start' });
      return;
    }
    if (event.target !== warrantyDialog) return;
    const bounds = warrantyDialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
      warrantyDialog.close();
    }
  });

  prepareLinks();
  document.addEventListener('cart:update', prepareLinks);
}
